import { render, staticRenderFns } from "./serveList.vue?vue&type=template&id=fa4e4c00&scoped=true&"
import script from "./serveList.vue?vue&type=script&lang=js&"
export * from "./serveList.vue?vue&type=script&lang=js&"
import style0 from "./serveList.vue?vue&type=style&index=0&id=fa4e4c00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4e4c00",
  null
  
)

export default component.exports